import { IOffer } from '../../packages/api-models/search-offers/v2/types';
import { TUser } from './user';

interface IBuldingQuarterPresenter {
  [index: string]: string;
}

export const BuildingQuarter: IBuldingQuarterPresenter = {
  first: '1',
  fourth: '4',
  second: '2',
  third: '3',
};

export interface IExtendedOffer extends IOffer {
  href: string;
  isWide: boolean;
  isNewbuilding: boolean;
  isTop: boolean;
}

export {
  IHighwayInfo,
  IRailway,
  IUnderground,
  EOfferFeatureLabelsV2Types,
  EPhotoLabelColor,
  ELocationTypeId,
  ENewbuildingSnippetType,
  IOfferHouse,
  EBrandingLevel,
  IGeo,
  TOfferType,
  ISearchOfferLabel,
  IUtilitiesTerms,
  TOfferCategory,
  IDiscount,
  IOfferPhoto,
  IAddress,
  IPhone,
  IOffer,
} from '../../packages/api-models/search-offers/v2/types';

export interface IOfferCard extends Omit<IOffer, 'user'> {
  offerUser: IOffer['user'];
  user: TUser;
}
